export const getOssAttributionLink = () => {
  if (process.env.REACT_APP_STAGE === 'prod') {
    return 'https://legal.hconnect.digital/ossattribution'
  } else if (location.hostname === 'localhost') {
    return 'http://localhost:3000/ossattribution'
  } else {
    return `https://legal-${process.env.REACT_APP_STAGE}.hconnect.digital/ossattribution`
  }
}
